import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import * as actions from '../actions';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import sampleCombine from 'xstream/extra/sampleCombine';
import delay from 'xstream/extra/delay';
import HEADER_FUNCTIONS from '../utils/functions/headers';

const REQUEST_CLAIM_TYPES = 'requestClaimTypes';
const REQUEST_CLAIM_TYPES_BY_POLICY_TYPE_AND_CLAIM_CATEGORY =
    'requestClaimTypesByPolicyTypeAndClaimCategory';

export function requestClaimTypes(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action => action.type === ActionTypes.FETCH_CLAIM_TYPES,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: GENERAL_FUNCTIONS.getBaseURL() + 'api/claimTypes',
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: REQUEST_CLAIM_TYPES,
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(REQUEST_CLAIM_TYPES)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchClaimTypesSuccess(response)
                : actions.fetchClaimTypesFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function requestQuestionGroupStepsWhenClaimTypesAreEmpty(sources) {
    const state$ = sources.STATE;
    const answers$ = state$.map(state => state.answer.answer);

    const action$ = sources.ACTION.filter(
        action =>
            action.type ===
            ActionTypes.FETCH_CLAIM_TYPES_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_SUCCESS,
    )
        .filter(action => action.payload && !action.payload.body.data)
        .compose(sampleCombine(answers$))
        .map(([action, answers]) =>
            actions.fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimType(
                {
                    policyTypeCode: answers.policyType,
                    claimCategoryCode: answers.claimCategory,
                    claimTypeCode: '___',
                },
            ),
        );
    return {
        ACTION: action$,
    };
}

export function requestClaimTypesByPolicyTypeAndClaimCategory(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action =>
            action.type ===
            ActionTypes.FETCH_CLAIM_TYPES_BY_POLICY_TYPE_AND_CLAIM_CATEGORY,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: `${GENERAL_FUNCTIONS.getBaseURL()}api/ClaimType/PolicyTypeCode/${action.payload.policyTypeCode}/ClaimCategoryCode/${action.payload.claimCategoryCode}`,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: REQUEST_CLAIM_TYPES_BY_POLICY_TYPE_AND_CLAIM_CATEGORY,
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(
        REQUEST_CLAIM_TYPES_BY_POLICY_TYPE_AND_CLAIM_CATEGORY,
    )
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchClaimTypesByPolicyTypeAndClaimCategorySuccess(
                      response,
                  )
                : actions.fetchClaimTypesByPolicyTypeAndClaimCategoryFailed(
                      response,
                  ),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}
